// constants
import { DNS_PREFIX_REGEXP } from '../branch/constants';
import { FIELD_BRANCH_DNS_PREFIX } from '../../constants';
// utilities
import { createApiUrl } from '../../utilities/http';
//////////////////////////////////////////////////

const LOCALHOST = 'localhost';
const AZURE_SSO_LOGIN_SERVICE_PATH = 'user:user/sso/azure/loginUrl';

const isValidDnsPrefix = (dnsPrefix) => (
  typeof dnsPrefix === 'string' && DNS_PREFIX_REGEXP.test(dnsPrefix)
);

const getRootHostname = (hostname) => {
  const hostnameParts = hostname.split('.');

  return hostnameParts[hostnameParts.length - 1] === LOCALHOST
    ? LOCALHOST
    : hostnameParts.slice(-2).join('.');
};

export const getDnsPrefixFromHostname = (hostname) => {
  const rootHostname = getRootHostname(hostname);

  if (hostname === rootHostname) return undefined;

  const [dnsPrefix] = hostname.split('.');

  return isValidDnsPrefix(dnsPrefix) ? dnsPrefix.toLowerCase() : undefined;
};

export const createAzureSsoRedirectUrl = (
  hostname = window.location.hostname,
  loginUrl = createApiUrl(AZURE_SSO_LOGIN_SERVICE_PATH),
) => {
  const dnsPrefix = getDnsPrefixFromHostname(hostname);
  const redirectUrl = new window.URL(loginUrl);

  if (dnsPrefix) redirectUrl.searchParams.set(FIELD_BRANCH_DNS_PREFIX, dnsPrefix);

  return redirectUrl.toString();
};

export const createAzureSsoCallbackRedirectUrl = (
  dnsPrefix,
  currentUrl = window.location.href,
) => {
  if (!isValidDnsPrefix(dnsPrefix)) return undefined;

  const callbackUrl = new window.URL(currentUrl);
  const rootHostname = getRootHostname(callbackUrl.hostname);
  const targetHostname = `${dnsPrefix.toLowerCase()}.${rootHostname}`;
  const callbackHash = new window.URLSearchParams(callbackUrl.hash.replace(/^#/, ''));

  if (callbackUrl.hostname === targetHostname) return undefined;

  callbackUrl.hostname = targetHostname;
  callbackHash.delete(FIELD_BRANCH_DNS_PREFIX);
  callbackUrl.hash = callbackHash.toString();

  return callbackUrl.toString();
};
